import React from "react"
import { Calendar3, Clock, Check2 } from "react-bootstrap-icons"

export default function BenFees() {
  const fees = [
    {
      title: "Individual sessions",
      price: "£150"
    },
    {
      title: "Couple sessions",
      price: "£170"
    }
  ]

  const policies = [
    "10:00am to 8:00pm on weekdays",
    "48 hours notice required",
    "48 hour cancellation policy"
  ]

  return (
    <section id="fees" className="benServicesSection benFeesSection">
      <div className="profile-container">
        <div className="row justify-content-center">
          <div className="col-lg-10">

            <div className="benServicesIntro mb-0">
              <div className="benServicesEyebrowWrap">
                <span className="benServicesEyebrowLine"></span>
                <p className="benServicesEyebrow mb-0">FEES</p>
                <span className="benServicesEyebrowLine"></span>
              </div>

              <h1 className="benServicesHeading p-0 m-0">Fees</h1>

         
            </div>

            <div className="serviceCard ">
              <div className="serviceCardInner">

                <div className="d-flex align-items-center gap-3">
                  <div className="serviceIcon">
                    <Calendar3 className="serviceIconSvg" />
                  </div>

                  <div>
          
                    <p className="serviceText mb-0">
                      Fees apply to both assessment and ongoing treatment sessions.
                    </p>
                  </div>
                </div>

                <div className="row g-3 mt-2">
                  {fees.map((fee) => (
                    <div className="col-md-6" key={fee.title}>
                      <div className="serviceCard serviceCardOpen h-100">
                        <div className="serviceCardInner text-center">
                          <h3 className="serviceTitle mb-2">{fee.title}</h3>
                          <h2 className="benServicesHeading mb-0">{fee.price}</h2>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

              </div>
            </div>

            <div className="serviceCard">
              <div className="serviceCardInner">

                <div className="d-flex align-items-center gap-3 mb-3">
                  <div className="serviceIcon">
                    <Clock className="serviceIconSvg" />
                  </div>

                  <div>
                    <h3 className="serviceTitle mb-1">Appointments and policy</h3>
                  </div>
                </div>

                <div className="d-flex flex-wrap gap-2">
                  {policies.map((item) => (
                    <span className="serviceTag" key={item}>
                      <Check2 className="serviceTagIcon" />
                      {item}
                    </span>
                  ))}
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  )
}